import axios from 'axios';
import utils from '../utils/index';
import CryptoJS from 'crypto-js';
let SERVICE_URL = "https://sjfc5ew2wh.execute-api.af-south-1.amazonaws.com/reconciliation-api/";
const axiosInstance = axios.create({
  baseURL: SERVICE_URL,
});

const encryptAES = async (body) => {
  let secret = await utils.getAESSecret();
  const salt = CryptoJS.lib.WordArray.random(16);
  const iv = CryptoJS.lib.WordArray.random(16);

  const key = CryptoJS.PBKDF2(
    secret,
    salt, {
      keySize: 256 / 32,
      iterations: 10000,
      hasher: CryptoJS.algo.SHA256
    });
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(body), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).ciphertext;
  const salt_iv_concat = CryptoJS.lib.WordArray.create().concat(salt).concat(iv);
  const encrypted_concat = CryptoJS.lib.WordArray.create().concat(encrypted);
  return {
    aesdata: `${salt_iv_concat.toString(CryptoJS.enc.Base64)}:${encrypted_concat.toString(CryptoJS.enc.Base64)}`
  }
}

const decryptAES = async (data) => {
  try {
    const salt_len = 16;
    const iv_len = 16;
    let secret = await utils.getAESSecret();
    let split_data = data.split(':');
    let salt_iv = CryptoJS.enc.Base64.parse(split_data[0]);
    let encrypted = CryptoJS.enc.Base64.parse(split_data[1]);
    let salt = CryptoJS.lib.WordArray.create(
      salt_iv.words.slice(0, salt_len / 4)
    );
    let iv = CryptoJS.lib.WordArray.create(
      salt_iv.words.slice(0 + salt_len / 4, (salt_len + iv_len) / 4)
    );
    const key = CryptoJS.PBKDF2(
      secret,
      salt,
      { keySize: 256 / 32, iterations: 10000, hasher: CryptoJS.algo.SHA256 }
    );
    const decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.lib.WordArray.create(
          encrypted.words
        )
      },
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    let decrypted_str = decrypted.toString(CryptoJS.enc.Utf8);
    // console.log("decrypted_str - ", decrypted_str);
    let decryptedData = {};
    if (decrypted_str) {
      decryptedData = JSON.parse(decrypted_str);
    }

    return decryptedData;
  }
  catch (err) {
    console.log("decryptAES Error: ", err);
    return {};
  }
}

axiosInstance.interceptors.request.use(async function (config) {
  let encryptedBody = await encryptAES(config.data);
  config.data = { ...encryptedBody };
  // Do something before request is sent
  let accessToken = await utils.readStringDataFromlocalStorageAndDecrypt('AUTH_TOKEN');
  //  //if token is found add it to the header
  if (accessToken) {
    if (config.method !== 'OPTIONS') {
      console.log("AXIOS request interceptor -> add authorization header")
      config.headers.authorization = accessToken;
    }
  }
  return config;
}, function (error) {
  // Do something with request error
  console.log("Reject Request error");
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(async (response) => {
  if (response.data.aesdata) {
    console.log("Decrypt response");
    let decryptedData = await decryptAES(response.data.aesdata)
    response.data = { ...decryptedData };
  }
  return response;
}, err => {
  return new Promise(async (resolve, reject) => {
    const originalReq = err.config;
    if (err.response && err.response.data.aesdata) {
      console.log("Decrypt Error response");
      let decryptedData = await decryptAES(err.response.data.aesdata)
      err.response.data = { ...decryptedData };
    }
    if (err.response && err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
      console.log("REFRESHTOKEN")
      originalReq._retry = true;
      let res = fetch(`${SERVICE_URL}/users/refresh-token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: await utils.readStringDataFromlocalStorageAndDecrypt('AUTH_TOKEN')
        }),
      })
        .then(res => res.json())
        .then(async res => {
          console.log("### axiosInstance.interceptors response data: ###", res);
          let aesToken = await utils.encryptStringAES(res.data.token);
          let aesRecoveryToken = await utils.encryptStringAES(res.data.recovery_token);
          let aesOpenIdToken = await utils.encryptStringAES(res.data.openid_token);
          await utils.storeStringDataTolocalStorage('TOKEN', aesToken);
          await utils.storeStringDataTolocalStorage('AUTH_TOKEN', aesToken);
          await utils.storeStringDataTolocalStorage('RECOVERY_TOKEN', aesRecoveryToken);
          await utils.storeStringDataTolocalStorage('OPENID_TOKEN', aesOpenIdToken);
          originalReq.headers['Authorization'] = res.data.token;
          if (res.msg) {
            console.log(res.msg)
          }
          return axios(originalReq);
        })
        .catch(error => {
          console.log('axiosInstance.interceptors error', error.msg)
          console.log(error.msg)
          return reject(error)
        })
      resolve(res);
    }
    if (err && err.response) {
      console.log("Other error", err.response.data);
      return reject(err.response.data);
    } else {
      return reject(err)
    }
  });
});


export default axiosInstance;
